import React from "react";
import MarkmidPage from "@components/Pages/MarkmidPage/MarkmidPage";

export default function Software() {
    return <MarkmidPage />;
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            messages: (await import(`../locales/${locale}.json`)).default,
        },
    };
}
